(function () {
  'use strict';

  function syncCartOpen() {
    var open =
      document.documentElement.classList.contains('js-drawer-open') ||
      document.documentElement.classList.contains('js-drawer-open--cart') ||
      document.body.classList.contains('js-drawer-open') ||
      !!document.querySelector('.cart-drawer.is-open, .drawer--cart.is-open, #CartDrawer.is-open, .modal--quick-shop.is-active');
    document.body.classList.toggle('fh-cart-open', open);
  }

  var observer = new MutationObserver(syncCartOpen);
  observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

  function isDesktop() {
    return window.matchMedia('(min-width: 769px)').matches;
  }

  function selectedColor() {
    var checked = document.querySelector(
      '.variant-input-wrap[data-handle="color"] input:checked, .variant-input-wrap[data-handle="renk"] input:checked, .variant-input-wrap[data-handle="farbe"] input:checked, .variant__input--color-swatch:checked'
    );
    if (checked) return (checked.value || checked.getAttribute('data-color-name') || '').trim();
    var root = document.querySelector('[data-product-images]');
    if (root && root.getAttribute('data-fh-selected-color')) {
      return root.getAttribute('data-fh-selected-color').trim();
    }
    var anyColor = document.querySelector('[data-variant-color-label]');
    return anyColor ? anyColor.textContent.trim() : '';
  }

  function getSlideshow() {
    return document.querySelector('.template-product .product-slideshow, [data-product-images] .product-slideshow');
  }

  function getFlickity(slideshow) {
    if (!slideshow) return null;
    if (slideshow.flickity) return slideshow.flickity;
    if (window.Flickity) {
      try {
        return window.Flickity.data(slideshow);
      } catch (e) {
        return null;
      }
    }
    return null;
  }

  function getGalleryHold(slideshow) {
    var parent = slideshow.parentNode;
    var hold = parent && parent.querySelector('.fh-gallery-hold');
    if (hold) return hold;
    hold = document.createElement('div');
    hold.className = 'fh-gallery-hold';
    hold.setAttribute('hidden', '');
    hold.setAttribute('aria-hidden', 'true');
    if (parent) parent.appendChild(hold);
    return hold;
  }

  function collectGallerySlides(slideshow) {
    var hold = slideshow.parentNode && slideshow.parentNode.querySelector('.fh-gallery-hold');
    var slides = Array.prototype.slice.call(slideshow.querySelectorAll('.product-main-slide'));
    if (hold) {
      slides = slides.concat(Array.prototype.slice.call(hold.querySelectorAll('.product-main-slide')));
    }
    slides.sort(function (a, b) {
      function sortKey(el) {
        var raw = el.getAttribute('data-fh-sort');
        if (raw !== null && raw !== '') return Number(raw) || 0;
        return Number(el.getAttribute('data-index')) || 0;
      }
      return sortKey(a) - sortKey(b);
    });
    return slides;
  }

  function slideMatchesColor(slide, color) {
    if (!color) return true;
    var colors = (slide.getAttribute('data-fh-colors') || '').toLowerCase().trim();
    if (!colors) return true;
    var needle = color.replace(/\s+/g, '-');
    return colors.split('|').some(function (c) {
      c = c.trim();
      return c === color || c.replace(/\s+/g, '-') === needle;
    });
  }

  function bindGridZoom(slideshow, slides) {
    slides.forEach(function (slide, slideIndex) {
      var zoomBtn = slide.querySelector('.js-photoswipe__zoom');
      if (zoomBtn) zoomBtn.setAttribute('data-index', String(slideIndex));

      var img = slide.querySelector('.photoswipe__image');
      if (img && !img.dataset.fhZoomClick) {
        img.dataset.fhZoomClick = '1';
        img.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var btn = slide.querySelector('.js-photoswipe__zoom');
          if (!btn) return;
          var allImgs = slideshow.querySelectorAll('.photoswipe__image');
          var idx = Array.prototype.indexOf.call(allImgs, img);
          if (idx < 0) idx = slideIndex;
          btn.setAttribute('data-index', String(idx));
          btn.click();
        });
      }
    });
  }

  function slideParent(slideshow) {
    return slideshow.querySelector('.flickity-slider') || slideshow;
  }

  function putSlidesIn(parent, slides) {
    slides.forEach(function (slide) {
      parent.appendChild(slide);
    });
  }

  var lastGalleryColor;

  function applyVisibleSet(slideshow, color) {
    var hold = getGalleryHold(slideshow);
    var allSlides = collectGallerySlides(slideshow);
    var visible = [];
    allSlides.forEach(function (slide) {
      if (slideMatchesColor(slide, color)) visible.push(slide);
    });
    if (!visible.length) visible = allSlides.slice();
    allSlides.forEach(function (slide) {
      slide.classList.toggle('fh-media-hidden', visible.indexOf(slide) === -1);
    });
    visible.forEach(function (slide, i) {
      slide.setAttribute('data-index', String(i));
    });
    return { allSlides: allSlides, visible: visible, hold: hold };
  }

  function placeSlides(slideshow, set) {
    var parent = slideParent(slideshow);
    putSlidesIn(parent, set.visible);
    set.allSlides.forEach(function (slide) {
      if (set.visible.indexOf(slide) === -1) set.hold.appendChild(slide);
    });
  }

  function recoverGallery() {
    var slideshow = getSlideshow();
    if (!slideshow) return;
    var slider = slideshow.querySelector('.flickity-slider');
    if (slider) {
      Array.prototype.slice.call(slideshow.children).forEach(function (node) {
        if (node.classList && node.classList.contains('product-main-slide') && !node.classList.contains('fh-media-hidden')) {
          slider.appendChild(node);
        }
      });
    }
    var vp = slideshow.querySelector('.flickity-viewport');
    if (vp && !isDesktop() && vp.clientHeight < 50) {
      var vis = slideshow.querySelector('.product-main-slide:not(.fh-media-hidden)');
      var h = vis ? vis.offsetHeight : 0;
      if (h < 50) h = Math.round(window.innerWidth * 1.35);
      vp.style.height = h + 'px';
    }
    var flkty = getFlickity(slideshow);
    if (flkty && typeof flkty.resize === 'function') {
      try {
        flkty.resize();
      } catch (e) {}
    }
  }

  function selectVisibleSlide(flkty, visible) {
    if (!flkty || !visible.length) return;
    var target = 0;
    var start = slideshowStarting(visible);
    if (start) target = visible.indexOf(start);
    try {
      if (typeof flkty.select === 'function') flkty.select(target, false, true);
      else if (typeof flkty.goToSlide === 'function') flkty.goToSlide(target);
    } catch (e) {}
  }

  function slideshowStarting(visible) {
    var i;
    for (i = 0; i < visible.length; i++) {
      if (visible[i].classList.contains('starting-slide')) return visible[i];
    }
    return null;
  }

  /**
   * Desktop: stacked grid, hide other colors with CSS from first paint.
   * Mobile: park other-color slides so Flickity only swipes the selected color.
   * Do not re-select slide 0 on load or size-only changes — that causes FOUC.
   */
  function syncGallery(fromColorChange) {
    var slideshow = getSlideshow();
    if (!slideshow) return;

    slideshow.classList.add('fh-gallery-ready');
    var desktop = isDesktop();
    slideshow.classList.toggle('fh-gallery-grid', desktop);

    var color = selectedColor().toLowerCase();
    var imagesRoot = document.querySelector('[data-product-images]');
    var colorChanged = lastGalleryColor !== undefined && lastGalleryColor !== color;
    var firstRun = lastGalleryColor === undefined;
    if (color) lastGalleryColor = color;

    if (desktop) {
      if (imagesRoot) imagesRoot.setAttribute('data-has-slideshow', 'false');
      if (color && (fromColorChange || colorChanged)) {
        var desktopSet = applyVisibleSet(slideshow, color);
        placeSlides(slideshow, desktopSet);
        if (imagesRoot) imagesRoot.setAttribute('data-fh-selected-color', selectedColor());
      }
      var flktyDesktop = getFlickity(slideshow);
      if (flktyDesktop) {
        try {
          flktyDesktop.options.draggable = false;
          if (typeof flktyDesktop.updateDraggable === 'function') flktyDesktop.updateDraggable();
          if (typeof flktyDesktop.unbindDrag === 'function') flktyDesktop.unbindDrag();
        } catch (e) {}
      }
      slideshow.classList.remove('is-draggable');
      bindGridZoom(slideshow, collectGallerySlides(slideshow));
      recoverGallery();
      return;
    }

    if (imagesRoot) imagesRoot.setAttribute('data-has-slideshow', 'true');

    if (firstRun && !fromColorChange) {
      return;
    }
    if (!color) return;
    if (!fromColorChange && !colorChanged) return;

    var set = applyVisibleSet(slideshow, color);
    if (imagesRoot) imagesRoot.setAttribute('data-fh-selected-color', selectedColor());

    var flkty = getFlickity(slideshow);
    placeSlides(slideshow, set);

    if (!flkty) return;
    try {
      flkty.options.draggable = true;
      if (typeof flkty.updateDraggable === 'function') flkty.updateDraggable();
      flkty.reloadCells();
      selectVisibleSlide(flkty, set.visible);
      flkty.resize();
    } catch (e) {}
    recoverGallery();
  }

  function initDescClip() {
    document.querySelectorAll('.fh-desc-clip').forEach(function (el) {
      if (el.dataset.fhBound) return;
      el.dataset.fhBound = '1';
      el.classList.add('fh-desc-clamp');

      // Measure after clamp applied
      requestAnimationFrame(function () {
        var overflowing = el.scrollHeight > el.clientHeight + 2;
        if (!overflowing) {
          el.classList.add('is-expanded');
          el.classList.remove('fh-desc-clamp');
          return;
        }

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'fh-desc-toggle';
        btn.textContent = 'Devamını oku';
        el.insertAdjacentElement('afterend', btn);
        btn.addEventListener('click', function () {
          var open = el.classList.toggle('is-expanded');
          el.classList.toggle('fh-desc-clamp', !open);
          btn.textContent = open ? 'Daha az göster' : 'Devamını oku';
        });
      });
    });
  }

  function enhanceHeroSliders() {
    document.querySelectorAll('[class*="ai-hero-slider-"]').forEach(function (root) {
      if (root.dataset.fhDrag) return;
      var track = root.querySelector('[class*="ai-hero-slider-track-"]');
      if (!track) return;
      root.dataset.fhDrag = '1';

      var startX = 0;
      var dragging = false;

      function onDown(x) {
        dragging = true;
        startX = x;
      }
      function onUp(x) {
        if (!dragging) return;
        dragging = false;
        var diff = startX - x;
        if (Math.abs(diff) < 40) return;
        var next = root.querySelector('[class*="ai-hero-slider-nav-next-"]');
        var prev = root.querySelector('[class*="ai-hero-slider-nav-prev-"]');
        if (diff > 0 && next) next.click();
        if (diff < 0 && prev) prev.click();
      }

      track.addEventListener('mousedown', function (e) {
        onDown(e.clientX);
      });
      window.addEventListener('mouseup', function (e) {
        onUp(e.clientX);
      });
      root.addEventListener('touchstart', function (e) {
        onDown(e.changedTouches[0].screenX);
      }, { passive: true });
      root.addEventListener('touchend', function (e) {
        onUp(e.changedTouches[0].screenX);
      }, { passive: true });
    });
  }

  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.matches('[data-variant-input], .variant__input--color-swatch, input[type="radio"]')) {
      return;
    }
    var isColor =
      e.target.classList.contains('variant__input--color-swatch') ||
      (e.target.closest && e.target.closest('.variant-input-wrap[data-handle="color"], .variant-input-wrap[data-handle="renk"], .variant-input-wrap[data-handle="farbe"]'));
    if (isColor) syncGallery(true);
  });

  window.addEventListener(
    'resize',
    function () {
      clearTimeout(window.__fhResize);
      window.__fhResize = setTimeout(function () {
        syncGallery();
        var flkty = getFlickity(getSlideshow());
        if (flkty) {
          try {
            flkty.resize();
          } catch (e) {}
        }
      }, 150);
    },
    { passive: true }
  );

  function syncBuyNowVisibility(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var buttons = scope.querySelectorAll('[data-add-to-cart], button.add-to-cart');
    if (!buttons.length && scope.querySelectorAll) {
      buttons = document.querySelectorAll('[data-add-to-cart], button.add-to-cart');
    }
    for (var i = 0; i < buttons.length; i++) {
      var atc = buttons[i];
      var soldOut = !!(atc.disabled || atc.hasAttribute('disabled'));
      var wrap = atc.closest('form') || atc.closest('.product-single') || atc.closest('.product-section') || document;
      var targets = wrap.querySelectorAll('.fh-buy-now, .shopify-payment-button, shopify-buy-it-now-button');
      for (var j = 0; j < targets.length; j++) {
        if (soldOut) targets[j].setAttribute('hidden', '');
        else targets[j].removeAttribute('hidden');
      }
    }
  }

  function revealNativeVariantPickers() {
    if (document.getElementById('fh-variant-picker-override-js')) return;
    var style = document.createElement('style');
    style.id = 'fh-variant-picker-override-js';
    style.textContent =
      'main#MainContent .product-section:not(.is-modal) .product-block .variant-wrapper,' +
      'main#MainContent .product-block .variant-wrapper,' +
      '.product-section .product-block .variant-wrapper,' +
      '.product-single .variant-wrapper{display:block!important}' +
      '.template-product .product-single .swatches-globo,' +
      '.template-product .product-section .swatches-globo{display:none!important}';
    document.documentElement.appendChild(style);
  }

  function visibleCellIndex(slideshow, mediaId) {
    var cells = slideshow.querySelectorAll('.product-main-slide:not(.fh-media-hidden)');
    var i;
    for (i = 0; i < cells.length; i++) {
      if (String(cells[i].getAttribute('data-media-id')) === String(mediaId)) return i;
    }
    return cells.length ? 0 : -1;
  }

  function patchVariantImageJump() {
    if (!window.theme || !theme.Product || !theme.Product.prototype || theme.Product.prototype.__fhPatched) return;
    theme.Product.prototype.__fhPatched = true;
    var origUpdate = theme.Product.prototype.updateVariantImage;
    var origInit = theme.Product.prototype.initProductSlider;

    if (typeof origInit === 'function') {
      theme.Product.prototype.initProductSlider = function (variant) {
        var slideshow = this.cache && this.cache.mainSlider;
        if (slideshow) {
          var start =
            slideshow.querySelector('.starting-slide:not(.fh-media-hidden)') ||
            slideshow.querySelector('.product-main-slide:not(.fh-media-hidden)');
          if (start) {
            var idx = visibleCellIndex(slideshow, start.getAttribute('data-media-id'));
            if (idx < 0) idx = 0;
            start.setAttribute('data-index', String(idx));
            this.settings.currentSlideIndex = idx;
          }
        }
        return origInit.apply(this, arguments);
      };
    }

    if (typeof origUpdate !== 'function') return;
    theme.Product.prototype.updateVariantImage = function (evt) {
      var variant = evt && evt.detail && evt.detail.variant;
      var slideshow = this.cache && this.cache.mainSlider;
      if (!variant || !variant.featured_media || !slideshow || !this.flickity) {
        return;
      }
      var idx = visibleCellIndex(slideshow, variant.featured_media.id);
      if (idx < 0) return;
      try {
        this.flickity.goToSlide(idx);
      } catch (e) {}
    };
  }

  patchVariantImageJump();

  function boot() {
    revealNativeVariantPickers();
    patchVariantImageJump();
    syncGallery();
    initDescClip();
    enhanceHeroSliders();
    syncCartOpen();
    syncBuyNowVisibility();
    setTimeout(recoverGallery, 200);
    setTimeout(recoverGallery, 700);
    setTimeout(syncBuyNowVisibility, 400);
    setTimeout(syncBuyNowVisibility, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    syncGallery();
    initDescClip();
    enhanceHeroSliders();
    syncBuyNowVisibility();
  });

  document.addEventListener('variant:change', function () {
    syncBuyNowVisibility();
  });
  document.addEventListener('variantChange', function () {
    syncBuyNowVisibility();
  });
})();
